import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/ClickIdCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredGoogleAdsEnhancedTracking"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/tracking/DeferredGoogleAdsEnhancedTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/ui/StickyCTAs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"optional\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"poppins\"}");
